import { IServiceBook } from './../../../_models/profile-sections/IServiceBook';
import { IServiceBookLog } from './../../../_models/profile-sections/IServiceBookLog';
import { IProfile, IProfileStatus } from './../../../_models/account/IProfile';
import { IProfileLog, IProfileStatusLog } from './../../../_models/account/IProfileLog';
import { ISpouseOutInfo } from './../../../_models/profile-sections/ISpouseOutInfo';
import { SpouseOutInfoService } from './../../../shared/services/spouse-out-info.service';
import { ISpouseInInfo } from './../../../_models/profile-sections/ISpouseInInfo';
import { SpouseInInfoService } from './../../../shared/services/spouse-in-info.service';
import { ISingleWomenInfo } from './../../../_models/profile-sections/ISingleWomenInfo';
import { SingleWomenInfoService } from './../../../shared/services/single-women-info.service';
import { IDiseaseInfo } from './../../../_models/profile-sections/IDiseaseInfo';
import { DiseaseInfoService } from './../../../shared/services/disease-info.service';
import { DisabledInfoService } from './../../../shared/services/disabled-info.service';
import { IDisabledInfo } from './../../../_models/profile-sections/IDisabledInfo';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { ITransferRequestLog } from './../../../_models/transfer-sections/ITransferRequestLog';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ISetting } from 'src/app/_models/cms/ISetting';
import { SettingService } from 'src/app/shared/services/setting.service';

@Component({
  selector: 'app-transfer-request-view',
  templateUrl: './transfer-request-view.component.html',
  styleUrls: ['./transfer-request-view.component.css']
})
export class TransferRequestViewComponent implements OnInit {
  skeleton: boolean = true;
  profile: IProfile;
  transferRequest: ITransferRequest;
  profileStatus: IProfileStatus;
  profileLog: IProfileLog;
  transferRequestLog: ITransferRequestLog;  
  profileStatusLog: IProfileStatusLog;
  setting: ISetting;
  id;
  financialYearId;
  phaseId;

  constructor(
    private service: TransferRequestService,
    private disabledInfoService: DisabledInfoService,
    private diseaseInfoService: DiseaseInfoService,
    private singleWomenInfoService: SingleWomenInfoService,
    private spouseInInfoService: SpouseInInfoService,
    private spouseOutInfoService: SpouseOutInfoService,
    private settingService: SettingService,
    private route: ActivatedRoute,
    private router: Router) {
    this.id = this.route.snapshot.paramMap.get('profileId');
    this.financialYearId = this.route.snapshot.paramMap.get('financialYearId');
    this.phaseId = this.route.snapshot.paramMap.get('phaseId');
  }

 async ngOnInit() {
    this.setting = await this.settingService.getSetting();
    this.setting = await this.settingService.getSetting();
    this.settingService.getSetting().then(data => {
      this.setting = data;
    });
    if(this.setting?.financialYearId == this.financialYearId){
    this.getTransferRequest();
    } 
    else{
    this.getTransferRequestLog();
    //this.getTransferRequest();
    }
}     

  goBack(): void {
    const page = localStorage.getItem('relativeUrl'); 
    this.router.navigateByUrl(page);
  }

  getTransferRequestLog() {
    if (this.id)
      this.service.getByProfileId(this.id, this.financialYearId,this.phaseId).subscribe((response: ITransferRequestLog) => {
        if (response) {
          this.transferRequestLog = response;
          this.profileLog = this.transferRequestLog.profileLog;
           this.getDisabledInfoLog();
          this.getDiseaseInfoLog();
          this.getSingleWomenInfoLog();
          this.getSpouseInInfoLog();
          this.getSpouseOutInfoLog();
          this.getProfileStatusLog();
        }
      },
        (error) => console.log('HTTP Error', error),
        () => this.skeleton = false);
  }

  getProfileStatusLog() {
    this.service.getProfileStatusLog(this.transferRequestLog.id).subscribe((response: IProfileStatusLog) => {
      if (response) {
        this.profileStatusLog = response;
      }
    });
  }

  getDisabledInfoLog() {
    this.disabledInfoService.getByProfileId(this.transferRequestLog.profileId).subscribe((response: IDisabledInfo) => {
      if (response) {
        this.transferRequestLog.profileLog.disabledInfoLog.push(response);
      }
    });
  }
  getDiseaseInfoLog() {
    this.diseaseInfoService.getByProfileId(this.transferRequestLog.profileId).subscribe((response: IDiseaseInfo) => {
      if (response) {
        this.transferRequestLog.profileLog.diseaseInfoLog.push(response);
      }
    });
  }
  getSingleWomenInfoLog() {
    this.singleWomenInfoService.getByProfileId(this.transferRequestLog.profileId).subscribe((response: ISingleWomenInfo) => {
      if (response) {
        this.transferRequestLog.profileLog.singleWomenInfoLog.push(response);
      }
    });
  }
  getSpouseInInfoLog() {
    this.spouseInInfoService.getByProfileId(this.transferRequestLog.profileId).subscribe((response: ISpouseInInfo) => {
      if (response) {
        this.transferRequestLog.profileLog.spouseInfoLogs.push(response);
      }
    });
  }
  getSpouseOutInfoLog() {
    this.spouseOutInfoService.getByProfileId(this.transferRequestLog.profileId).subscribe((response: ISpouseOutInfo) => {
      if (response) {
        this.transferRequestLog.profileLog.SpouseOutInfoLogs.push(response);  
      } 
    });
  }

  getCategoriesLog(item: IProfileLog) {      
    let transferCategories: string = "";
    let presentPlace: IServiceBookLog = item.serviceBookLog.find(x => x.isPresent);
    if (item.disabledInfoLog[0]) {
      transferCategories = transferCategories + "PH <br/>";
    }
    if (item.diseaseInfoLog[0]) {
      transferCategories = transferCategories + " Medical <br/>";
    }
    if (this.isPresentHardLog(presentPlace)) {
      transferCategories = transferCategories + " H/VH/SH <br/>";
    }
    //if (this.isPresentPlan(presentPlace) && !item.disabledInfoLog[0] && !item.diseaseInfoLog[0] && !item.singleWomenInfoLog[0] && !item.spouseOutInfos[0] && !item.spouseInInfos[0] && !item.isRetirementNear) {
    if (this.isPresentPlanLog(presentPlace) && !item.disabledInfoLog[0] && !item.diseaseInfoLog[0] && !item.singleWomenInfoLog[0] &&  !item.isRetirementNear) {
      transferCategories = transferCategories + " Plane <br/>";
    }
    if (item.singleWomenInfoLog[0]) {
      transferCategories = transferCategories + " Single Lady <br/>";
    }
    // if (item.spouseInInfos[0]) {
    //   transferCategories = transferCategories + " NVS Spouse <br/>";
    // }
    // if (item.spouseOutInfos[0]) {
    //   transferCategories = transferCategories + " Central/State Spouse <br/>";
    // }
    if (item?.isRetirementNear) {
      transferCategories = transferCategories + " Due For Retirement (DFR) <br/>";
    }
    return transferCategories;
  }

  getPrincipalEligibleCategoryLog(item: IProfileStatusLog, profileLog: IProfileLog) {
    let principalEligibleCategories = '';
    let presentPlace: IServiceBookLog = profileLog.serviceBookLog.find(x => x.isPresent);
    if (item.isPrincipalDisabled == true) {
      principalEligibleCategories = principalEligibleCategories + "PH <br/>";
    }
    if (item.isPrincipalDisease == true) {
      principalEligibleCategories = principalEligibleCategories + " Medical <br/>";
    }
    if (this.isPresentHardLog(presentPlace)) {
      principalEligibleCategories = principalEligibleCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlanLog(presentPlace)
      && (item.isPrincipalDisabled != true && item.isPrincipalDisabled == null || item.isPrincipalDisabled == false) &&
      (item.isPrincipalDisease != true && item.isPrincipalDisease == null || item.isPrincipalDisease == false) &&
      (item.isPrincipalSingleWomen != true && item.isPrincipalSingleWomen == null || item.isPrincipalSingleWomen == false) &&
      (item.isPrincipalSpouseIn != true && item.isPrincipalSpouseIn == null || item.isPrincipalSpouseIn == false) &&
      (item.isPrincipalSpouseOut != true && item.isPrincipalSpouseOut == null || item.isPrincipalSpouseOut == false) &&
      (item.isPrincipalDueForRetire != true && item.isPrincipalDueForRetire == null || item.isPrincipalDueForRetire == false)
      && (profileLog.disabledInfoLog[0] === undefined || profileLog.diseaseInfoLog[0] === undefined
        || profileLog.singleWomenInfoLog[0] === undefined
        //  || profileLog.spouseOutInfos[0] === undefined
        // || profileLog.spouseInInfos[0] === undefined
        && (profileLog.isRetirementNear != true && profileLog.isRetirementNear == null || profileLog.isRetirementNear == false))) {
      principalEligibleCategories = principalEligibleCategories + " Plane <br/>";
    }
    if (item.isPrincipalSingleWomen == true) {
      principalEligibleCategories = principalEligibleCategories + " Single Lady <br/>";
    }
    if (item.isPrincipalSpouseIn == true) {
      principalEligibleCategories = principalEligibleCategories + " NVS Spouse <br/>";
    }
    if (item.isPrincipalSpouseOut == true) {
      principalEligibleCategories = principalEligibleCategories + " Central/State Spouse <br/>";
    }
    if (item?.isPrincipalDueForRetire) {
      principalEligibleCategories = principalEligibleCategories + " Due For Retirement (DFR) <br/>";
    }
    return principalEligibleCategories;
  }

  getROEligibleCategoryLog(item: IProfileStatusLog, profileLog: IProfileLog) {
    let rOEligibleCategories = '';
    let presentPlace: IServiceBookLog = profileLog.serviceBookLog.find(x => x.isPresent);
    if (item.isRODisabled == true) {
      rOEligibleCategories = rOEligibleCategories + "PH <br/>";
    }
    if (item.isRODisease == true) {
      rOEligibleCategories = rOEligibleCategories + " Medical <br/>";
    }
    if (this.isPresentHardLog(presentPlace)) {
      rOEligibleCategories = rOEligibleCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlanLog(presentPlace)
      && (item.isRODisabled != true && item.isRODisabled == null || item.isRODisabled == false) &&
      (item.isRODisease != true && item.isRODisease == null || item.isRODisease == false) &&
      (item.isROSingleWomen != true && item.isROSingleWomen == null || item.isROSingleWomen == false) &&
      (item.isROSpouseIn != true && item.isROSpouseIn == null || item.isROSpouseIn == false) &&
      (item.isROSpouseOut != true && item.isROSpouseOut == null || item.isROSpouseOut == false) &&
      (item.isRODueForRetire != true && item.isRODueForRetire == null || item.isRODueForRetire == false)
      && (profileLog.disabledInfoLog[0] === undefined || profileLog.diseaseInfoLog[0] === undefined
        || profileLog.singleWomenInfoLog[0] === undefined 
        // || profileLog.spouseOutInfos[0] === undefined
        // || profileLog.spouseInInfos[0] === undefined 
        && (profileLog.isRetirementNear != true && profileLog.isRetirementNear == null || profileLog.isRetirementNear == false))) {
      rOEligibleCategories = rOEligibleCategories + " Plane <br/>";
    }
    if (item.isROSingleWomen == true) {
      rOEligibleCategories = rOEligibleCategories + " Single Lady <br/>";
    }
    if (item.isROSpouseIn == true) {
      rOEligibleCategories = rOEligibleCategories + " NVS Spouse <br/>";     
    }
    if (item.isROSpouseOut == true) {
      rOEligibleCategories = rOEligibleCategories + " Central/State Spouse <br/>";
    }
    if (item?.isRODueForRetire) {
      rOEligibleCategories = rOEligibleCategories + " Due For Retirement (DFR) <br/>";
    }
    return rOEligibleCategories;
  }

  getPrincipalEligiblePlaneCategoryLog(profileLog: IProfileLog) {
    let principalEligibleCategories = '';
    let presentPlace: IServiceBookLog = profileLog.serviceBookLog.find(x => x.isPresent);
    if (this.isPresentPlanLog(presentPlace)) {
      principalEligibleCategories = principalEligibleCategories + " Plane <br/>";
    }
    return principalEligibleCategories;
  }
  getROEligiblePlaneCategoryLog(profileLog: IProfileLog) {
    let rOEligibleCategories = '';
    let presentPlace: IServiceBookLog = profileLog.serviceBookLog.find(x => x.isPresent);
    if (this.isPresentPlanLog(presentPlace)) {
      rOEligibleCategories = rOEligibleCategories + " Plane <br/>";
    }
    return rOEligibleCategories;
  }


  isPresentHardLog(presentPlace: IServiceBookLog) {
    return presentPlace ? (presentPlace.school.schoolTypeId > 1 ? true : false) : false;
  }
  isPresentPlanLog(presentPlace: IServiceBookLog) {
    return presentPlace ? (presentPlace.school.schoolTypeId == 1 ? true : false) : false;
  }
  get isConfirmLog(): boolean {
    return this.transferRequestLog ? this.transferRequestLog.isConfirm : false;
  }

  getTransferRequest() {  
    if (this.id)
      this.service.getByProfileId(this.id,this.financialYearId,this.phaseId).subscribe((response: ITransferRequest) => {
        if (response) {
          this.transferRequest = response;   
          this.profile = this.transferRequest.profile; 
          this.getDisabledInfo();
          this.getDiseaseInfo(); 
          this.getSingleWomenInfo();
          this.getSpouseInInfo(); 
          this.getSpouseOutInfo();
          this.getProfileStatus();            
        } 
      },
        (error) => console.log('HTTP Error', error),
        () => this.skeleton = false);
  }

  getProfileStatus() {
    this.service.getProfileStatus(this.transferRequest.id).subscribe((response: IProfileStatus) => {
      if (response) {
        this.profileStatus = response;
      }
    });
  }

  getDisabledInfo() {
    this.disabledInfoService.getByProfileId(this.transferRequest.profileId).subscribe((response: IDisabledInfo) => {
      if (response) {
        this.transferRequest.profile.disabledInfos.push(response);
      }
    });
  }
  getDiseaseInfo() {
    this.diseaseInfoService.getByProfileId(this.transferRequest.profileId).subscribe((response: IDiseaseInfo) => {
      if (response) {
        this.transferRequest.profile.diseaseInfos.push(response);
      }
    });
  }
  getSingleWomenInfo() {
    this.singleWomenInfoService.getByProfileId(this.transferRequest.profileId).subscribe((response: ISingleWomenInfo) => {
      if (response) {
        this.transferRequest.profile.singleWomenInfos.push(response);
      }
    });
  }
  getSpouseInInfo() {
    this.spouseInInfoService.getByProfileId(this.transferRequest.profileId).subscribe((response: ISpouseInInfo) => {
      if (response) {
        this.transferRequest.profile.spouseInInfos.push(response);
      }
    });
  }
  getSpouseOutInfo() {
    this.spouseOutInfoService.getByProfileId(this.transferRequest.profileId).subscribe((response: ISpouseOutInfo) => {
      if (response) {
        this.transferRequest.profile.spouseOutInfos.push(response);
      }
    });
  }

  getCategories(item: IProfile) {
    let transferCategories: string = "";
    let presentPlace: IServiceBook = item.serviceBooks.find(x => x.isPresent);
    if (item.disabledInfos[0]) {
      transferCategories = transferCategories + "PH <br/>";
    }
    if (item.diseaseInfos[0]) {
      transferCategories = transferCategories + " Medical <br/>";
    }
    if (this.isPresentHard(presentPlace)) {
      transferCategories = transferCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlan(presentPlace) && !item.disabledInfos[0] && !item.diseaseInfos[0] && !item.singleWomenInfos[0] && !item.spouseOutInfos[0] && !item.spouseInInfos[0] && !item.isRetirementNear) {
      transferCategories = transferCategories + " Plane <br/>";
    }
    if (item.singleWomenInfos[0]) {
      transferCategories = transferCategories + " Single Lady <br/>";
    }
    if (item.spouseInInfos[0]) {
      transferCategories = transferCategories + " NVS Spouse <br/>";
    }
    if (item.spouseOutInfos[0]) {
      transferCategories = transferCategories + " Central/State Spouse <br/>";
    }
    if (item?.isRetirementNear) {
      transferCategories = transferCategories + " Due For Retirement (DFR) <br/>";
    }
    return transferCategories;
  }

  getPrincipalEligibleCategory(item: IProfileStatus, profile: IProfile) {
    let principalEligibleCategories = '';
    let presentPlace: IServiceBook = profile.serviceBooks.find(x => x.isPresent);
    if (item.isPrincipalDisabled == true) {
      principalEligibleCategories = principalEligibleCategories + "PH <br/>";
    }
    if (item.isPrincipalDisease == true) {
      principalEligibleCategories = principalEligibleCategories + " Medical <br/>";
    }
    if (this.isPresentHard(presentPlace)) {
      principalEligibleCategories = principalEligibleCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlan(presentPlace)
      && (item.isPrincipalDisabled != true && item.isPrincipalDisabled == null || item.isPrincipalDisabled == false) &&
      (item.isPrincipalDisease != true && item.isPrincipalDisease == null || item.isPrincipalDisease == false) &&
      (item.isPrincipalSingleWomen != true && item.isPrincipalSingleWomen == null || item.isPrincipalSingleWomen == false) &&
      (item.isPrincipalSpouseIn != true && item.isPrincipalSpouseIn == null || item.isPrincipalSpouseIn == false) &&
      (item.isPrincipalSpouseOut != true && item.isPrincipalSpouseOut == null || item.isPrincipalSpouseOut == false) &&
      (item.isPrincipalDueForRetire != true && item.isPrincipalDueForRetire == null || item.isPrincipalDueForRetire == false)
      && (profile.disabledInfos[0] === undefined || profile.diseaseInfos[0] === undefined
        || profile.singleWomenInfos[0] === undefined || profile.spouseOutInfos[0] === undefined
        || profile.spouseInInfos[0] === undefined
        && (profile.isRetirementNear != true && profile.isRetirementNear == null || profile.isRetirementNear == false))) {
      principalEligibleCategories = principalEligibleCategories + " Plane <br/>";
    }
    if (item.isPrincipalSingleWomen == true) { 
      principalEligibleCategories = principalEligibleCategories + " Single Lady <br/>";
    }
    if (item.isPrincipalSpouseIn == true) {
      principalEligibleCategories = principalEligibleCategories + " NVS Spouse <br/>";
    }
    if (item.isPrincipalSpouseOut == true) {
      principalEligibleCategories = principalEligibleCategories + " Central/State Spouse <br/>";
    }
    if (item?.isPrincipalDueForRetire) {
      principalEligibleCategories = principalEligibleCategories + " Due For Retirement (DFR) <br/>";
    }
    return principalEligibleCategories;
  }

  getROEligibleCategory(item: IProfileStatus, profile: IProfile) {
    let rOEligibleCategories = '';
    let presentPlace: IServiceBook = profile.serviceBooks.find(x => x.isPresent);
    if (item.isRODisabled == true) {
      rOEligibleCategories = rOEligibleCategories + "PH <br/>";
    }
    if (item.isRODisease == true) {
      rOEligibleCategories = rOEligibleCategories + " Medical <br/>";
    }
    if (this.isPresentHard(presentPlace)) {
      rOEligibleCategories = rOEligibleCategories + " H/VH/SH <br/>";
    }
    if (this.isPresentPlan(presentPlace)
      && (item.isRODisabled != true && item.isRODisabled == null || item.isRODisabled == false) &&
      (item.isRODisease != true && item.isRODisease == null || item.isRODisease == false) &&
      (item.isROSingleWomen != true && item.isROSingleWomen == null || item.isROSingleWomen == false) &&
      (item.isROSpouseIn != true && item.isROSpouseIn == null || item.isROSpouseIn == false) &&
      (item.isROSpouseOut != true && item.isROSpouseOut == null || item.isROSpouseOut == false) &&
      (item.isRODueForRetire != true && item.isRODueForRetire == null || item.isRODueForRetire == false)
      && (profile.disabledInfos[0] === undefined || profile.diseaseInfos[0] === undefined
        || profile.singleWomenInfos[0] === undefined || profile.spouseOutInfos[0] === undefined
        || profile.spouseInInfos[0] === undefined && (profile.isRetirementNear != true && profile.isRetirementNear == null || profile.isRetirementNear == false))) {
      rOEligibleCategories = rOEligibleCategories + " Plane <br/>";
    }
    if (item.isROSingleWomen == true) {
      rOEligibleCategories = rOEligibleCategories + " Single Lady <br/>";
    }
    if (item.isROSpouseIn == true) {
      rOEligibleCategories = rOEligibleCategories + " NVS Spouse <br/>";
    }
    if (item.isROSpouseOut == true) {
      rOEligibleCategories = rOEligibleCategories + " Central/State Spouse <br/>";
    }
    if (item?.isRODueForRetire) {
      rOEligibleCategories = rOEligibleCategories + " Due For Retirement (DFR) <br/>";
    }
    return rOEligibleCategories;
  }

  getPrincipalEligiblePlaneCategory(profile: IProfile) {
    let principalEligibleCategories = '';
    let presentPlace: IServiceBook = profile.serviceBooks.find(x => x.isPresent);
    if (this.isPresentPlan(presentPlace)) {
      principalEligibleCategories = principalEligibleCategories + " Plane <br/>";
    }
    return principalEligibleCategories;
  }
  getROEligiblePlaneCategory(profile: IProfile) {
    let rOEligibleCategories = '';
    let presentPlace: IServiceBook = profile.serviceBooks.find(x => x.isPresent);
    if (this.isPresentPlan(presentPlace)) {
      rOEligibleCategories = rOEligibleCategories + " Plane <br/>";
    }
    return rOEligibleCategories;
  }


  isPresentHard(presentPlace: IServiceBook) {
    return presentPlace ? (presentPlace.school.schoolTypeId > 1 ? true : false) : false;
  }
  isPresentPlan(presentPlace: IServiceBook) {
    return presentPlace ? (presentPlace.school.schoolTypeId == 1 ? true : false) : false;
  }
  get isConfirm(): boolean {
    return this.transferRequest ? this.transferRequest.isConfirm : false;
  }

}
